export default {
    data() {
        return {
            noEmptyRule: [(v) => !!v || this.$t('servicesystem.rules.required_field')],
            notZeroRule: [(v) => v !== '0' || this.$t('servicesystem.rules.required_field')],

            emailRule: [
                (v) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || this.$t('servicesystem.rules.valid_mail'),
            ],
            noEmptyEmailRule: [
                (v) => !!v || this.$t('servicesystem.rules.reqired_mail'),
                (v) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || this.$t('servicesystem.rules.reqired_valid_mail'),
            ],
            phoneRule: [(v) => /^[0-9 +#-]*$/.test(v) || this.$t('servicesystem.rules.valid_tlf')],
            noEmptypPhoneRule: [
                (v) => !!v || this.$t('servicesystem.rules.required_field'),
                (v) => /^[0-9 +#-]*$/.test(v) || this.$t('servicesystem.rules.reqired_valid_tlf')
            ],
        };
    },
    methods: {

    }
}